<template>
  <div class="ml-3">
    <v-card-subtitle class="mt-0 mb-0 pb-0 pt-1">
      <!-- <v-icon class="mx-2">mdi-settings-outline</v-icon> -->
      <!-- :href="'/builder/items/' + item.uuid" -->
      <v-icon
        v-if="
          item.prettified_categories.length !== 0 &&
          !!item.prettified_categories[0].icon
        "
        >{{ item.prettified_categories[0].icon }}</v-icon
      >
      <span v-else class="mx-3"></span>
      <v-btn
        text
        class="text-capitalize grey--text text--darken-2"
        @click="showDetails = !showDetails"
        small
      >
        <span v-if="item.vendor">{{ item.vendor.name }} - {{ item.name }}</span>
        <span v-else>{{ item.name }}</span>
      </v-btn>
      <v-btn
        v-if="!isReadOnly"
        class="float-right"
        text
        x-small
        @click="deleteItem()"
      >
        <v-icon color="red">mdi-delete</v-icon>
      </v-btn>

      <v-btn
        text
        @click="showDetails = !showDetails"
        class="float-right"
        color="primary"
        x-small
      >
        <v-icon color="primary" class="mx-1" v-if="!showDetails"
          >mdi-eye-outline</v-icon
        >
        <v-icon color="primary" class="mx-1" v-else>mdi-eye-off-outline</v-icon>
      </v-btn>
    </v-card-subtitle>
    <v-card-text v-show="showDetails">
      <v-row v-if="item.description">
        <v-col cols="12" sm="12" md="12" lg="12">
          <span class="body-2 ml-8 caption">
            {{ item.description }}
          </span>
        </v-col>
      </v-row>
      <v-row v-if="item.documents">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          v-for="document in item.documents"
          :key="document.uuid"
          class="body-2"
        >
          <v-btn
            :href="'/builder/documents/' + document.uuid"
            class="ml-5"
            color="primary"
            text
            x-small
          >
            <v-icon color="primary" class="mx-1">mdi-file-document</v-icon>
            {{ document.file_resource.title }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col cols="12" sm="12" md="12" lg="12">
          <span class="body-2 ml-6">
            {{ $t("components.items.itemComponents.nothingToShow") }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import categories from "@/utils/categories.js";
export default {
  name: "ItemComponent",
  props: ["item", "readonly"],
  created() {
    this.categoryOptions = categories.categoryOptions();
    this.prettifyCategories(this.item);
    this.sortPrettifiedCategories(this.item);
  },
  computed: {
    isReadOnly() {
      return !!this.readonly;
    },
  },
  data: () => ({
    showDetails: false,
    categoryOptions: [],
  }),
  methods: {
    prettifyCategories(variable) {
      let prettifyCategory = (element) => {
        element.prettified_categories = [];
        element.categories.forEach((category) => {
          var prettified_category = this.categoryOptions.find(
            (categoryOption) => category === categoryOption.category
          );
          if (typeof prettified_category !== "undefined") {
            element.prettified_categories.push(prettified_category);
          } else {
            element.prettified_categories.push({
              category: category,
              icon: "mdi-help",
            });
          }
        });
        return element;
      };

      if (Array.isArray(variable)) {
        variable.forEach((element) => {
          prettifyCategory(element);
        });
      } else {
        prettifyCategory(variable);
      }
      return variable;
    },

    sortPrettifiedCategories(object, status) {
      let sortPrettifiedCategory = (element) => {
        element.prettified_categories.sort((first) => {
          var index = this.categoryOptions
            .map((category) => category.category)
            .findIndex((category) => {
              return category === first.category;
            });
          if (index !== -1) {
            return -1;
          } else {
            return 1;
          }
        });
      };

      if (status) {
        for (let key in object) {
          object[key].forEach((element) => {
            sortPrettifiedCategory(element);
          });
        }
      } else {
        sortPrettifiedCategory(object);
      }

      return object;
    },
    deleteItem() {
      this.$emit("delete-item");
    },
  },
};
</script>
